import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-10f694ce")

_pushScopeId("data-v-10f694ce")
const _hoisted_1 = { class: "cx-login modal-dialog" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = {
  class: "modal-title",
  id: "myModalLabel"
}
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "well" }
const _hoisted_8 = {
  id: "frm_login",
  class: "animated fadeIn"
}
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "control-label" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "control-label" }
const _hoisted_13 = /*#__PURE__*/_createVNode("span", { class: "help-block" }, null, -1)
const _hoisted_14 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_15 = { class: "checkbox check-success" }
const _hoisted_16 = { for: "remember_me" }
const _hoisted_17 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_cx_spinner = _resolveComponent("cx-spinner")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("h4", _hoisted_4, _toDisplayString(_ctx.translations.welcome), 1)
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          (_ctx.isSilentLoginInProgress || _ctx.isSilentRedirectInProgress)
            ? (_openBlock(), _createBlock(_component_cx_spinner, {
                key: 0,
                loading: true,
                size: 120,
                color: "#2d84d7"
              }))
            : _createCommentVNode("", true),
          (!_ctx.isSilentLoginInProgress && !_ctx.isSilentRedirectInProgress)
            ? (_openBlock(), _createBlock("div", {
                key: 1,
                class: "col-md-12",
                onKeydown: _cache[6] || (_cache[6] = $event => (_ctx.handleKeyDown($event, _ctx.logIn)))
              }, [
                _createVNode("div", _hoisted_7, [
                  _createVNode("div", _hoisted_8, [
                    _createVNode("div", _hoisted_9, [
                      _createVNode("label", _hoisted_10, _toDisplayString(_ctx.translations.username), 1),
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        class: "form-control",
                        placeholder: _ctx.translations.username,
                        maxlength: 254,
                        id: "id_username",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.username = $event)),
                        autofocus: ""
                      }, null, 8, ["placeholder"]), [
                        [_vModelText, _ctx.username]
                      ])
                    ]),
                    _createVNode("div", _hoisted_11, [
                      _createVNode("label", _hoisted_12, _toDisplayString(_ctx.translations.password), 1),
                      _withDirectives(_createVNode("input", {
                        type: "password",
                        id: "id_password",
                        class: "form-control",
                        placeholder: _ctx.translations.password,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_ctx.password = $event))
                      }, null, 8, ["placeholder"]), [
                        [_vModelText, _ctx.password]
                      ]),
                      _hoisted_13
                    ]),
                    (_ctx.currentErrorType)
                      ? (_openBlock(), _createBlock("div", _hoisted_14, [
                          _createVNode("span", null, _toDisplayString(_ctx.errorText), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode("div", _hoisted_15, [
                      _withDirectives(_createVNode("input", {
                        type: "checkbox",
                        id: "remember_me",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (_ctx.rememberMe = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.rememberMe]
                      ]),
                      _createVNode("label", _hoisted_16, _toDisplayString(_ctx.translations.remember), 1)
                    ]),
                    _createVNode("button", {
                      id: "id_login",
                      class: "btn btn-default btn-block",
                      onClick: _cache[4] || (_cache[4] = (...args) => (_ctx.logIn(...args)))
                    }, [
                      (!_ctx.isLoginQueryInProgress)
                        ? (_openBlock(), _createBlock("span", _hoisted_17, _toDisplayString(_ctx.translations.login), 1))
                        : _createCommentVNode("", true),
                      (_ctx.isLoginQueryInProgress)
                        ? (_openBlock(), _createBlock(_component_cx_spinner, {
                            key: 1,
                            loading: true,
                            size: 20,
                            color1: "white",
                            stroke1: 2,
                            stroke2: 0.5
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode("button", {
                      class: "btn btn-block",
                      onClick: _cache[5] || (_cache[5] = (...args) => (_ctx.navigateToRecovery(...args)))
                    }, _toDisplayString(_ctx.translations.reset), 1)
                  ])
                ])
              ], 32))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
})